import React, {
  useState,
  Fragment,
  useEffect,
  useRef,
} from "react";
import { Button, Input } from "reactstrap";
import { connect, useSelector } from "react-redux";
import * as pdfjsLib from "pdfjs-dist/webpack";
import {
  STEP_2_REMOVE_DOCUMENT,
  STEP_2_INSERT_DOCUMENT_BETWEEN_PAGES,
  SET_STEP_2_UPDATE_DOCUMENT,
  STEP_2_UPDATE_DOCUMENTS_ARRAY,
} from "../../../redux/actions/ActionTypes";
import Swal from "sweetalert2";
import { bindActionCreators } from "redux";
import {
  
  getAlertToast,
} from "../../../utils/functions/CustomFunctions";
import CustomPageLoading from "../../../utils/functions/CustomPageLoading";
import API from "../../../redux/actions/API";
import { FILE_UPLOAD_URL } from "../../../utils/APIEndpoints";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import PlaceholderBuildDialog from "./PlaceholderBuildDialog";
import CustomLoader from "../../common/CustomLoader";
// import crossCheckIcon from '../../../assets/check-icons/cross-check.png';
// import dotCheckIcon from '../../../assets/check-icons/dot-check.png';
// import tickCheckIcon from '../../../assets/check-icons/tick-check.png';
import CrossUnCheck from "../../../assets/check-icons/cross-uncheck.png";
import DotUnCheck from "../../../assets/check-icons/dot-uncheck.png";
import TickUnCheck from "../../../assets/check-icons/tick-uncheck.png";
import { Rnd } from "react-rnd";
import shortid from "shortid";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const checkboxImagesType = {
  Cross: CrossUnCheck,
  Tick: TickUnCheck,
  Dot: DotUnCheck,
};

const checkboxImagesSize = {
  Small: 10,
  Medium: 20,
  Large: 30,
};
const initialForm = {
  xCord: 0,
  yCord: 0,
  placeholder: "",
  propertyType: "Text",
  fontSize: "9",
  justify: "Left",
  isBold: false,
  isItalic: false,
  isRequired: false,
  width: 100,
  height: 27,
  imageValue: "",
  textValue: "",
  checkboxType: "Tick",
  checkboxSize: "Medium",
  checkboxValue: false,
  maskedvalue: "",
  maskedvalueold: "",
};
function BuildDocument(props) {
  const { record = {}, documentIndex, dispatch, CreateDocumentForm } = props;
  const { step2 = {}, currentStep = 0 } = CreateDocumentForm;
  const { allDocuments = [] } = step2;
  const childRef = useRef();
  const [TimerValue, setTimerValue] = useState(false);
  const [value, setValue] = useState(false);
  const { elements = [], documentURL = "" } = record;
  const [dialogFlag, setDialogFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [maskedvalues, setMaskedvalues] = useState("");

  const [pdfDimension, setPdfDimension] = useState({
    width: 700,
    height: 900,
  });
  const HandleDocumentFormat = useSelector(
    (state) => state.HandleDocumentFormat
  );
  const { documentsType = "" } = HandleDocumentFormat;
  // useEffect(() => {
  //   debugger;
  //   document.addEventListener("keydown", keydownHandler);
  //   document.addEventListener("keyup", keyupHandler);
  //   return () => {
  //     document.removeEventListener("keydown", keydownHandler);
  //     document.removeEventListener("keyup", keyupHandler);
  //   };
  // }, []);
  const generatePdf = async () => {
    if (documentURL) {
      let loadingTask = pdfjsLib.getDocument({ url: documentURL });
      loadingTask.onProgress = function (progress) {
        setLoading(true);
        // Swal.fire(
        //   getAlertToast("success", "Please wait...", 2000)
        // );
      };
      loadingTask.promise
        .then(function (doc) {
          setLoading(false);
          // load pdf
          return doc.getPage(1).then((page) => {
            let canvasId = `canvas_${documentIndex}`;
            var canvas = document.getElementById(canvasId);
            if (!canvas) {
              return;
            }
            var context = canvas.getContext("2d");
            var viewport = page.getViewport({ scale: 1 });
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            setPdfDimension({
              width: viewport.width,
              height: viewport.height,
            });
            return page.render({
              canvasContext: context,
              viewport: viewport,
            }).promise;
          });
          // .catch((error) => {
          //   Swal.fire(getAlertToast('error', 'File loading failed'));
          // });
        })
        .catch((error) => {
          console.error("PDF loading failed", error);
          setLoading(false);
          Swal.fire(getAlertToast("error", "File loading failed", 2000));
        });
    }
  };
  //doubleclick
  let timer = 0;
  let delay = 200;
  let prevent = false;
  // Double Click
  const onDoubleClick = (elementId) => {
    clearTimeout(timer);
    prevent = true;
    let elementData = elements.find(
      (element) => element.elementId === elementId
    );
    setDialogFlag(elementData);
    setTimeout(() => {
      prevent = false;
    }, delay);
  };

  const onCanvasClick = (e) => {
    const documentIndex = e.currentTarget.dataset.document_id;
    var x;
    var y;
    if (e.nativeEvent.offsetX || e.nativeEvent.offsetY) {
      x = e.nativeEvent.offsetX;
      y = e.nativeEvent.offsetY;
    } else {
      x =
        e.clientX +
        document.body.scrollLeft +
        document.documentElement.scrollLeft;
      y =
        e.clientY +
        document.body.scrollTop +
        document.documentElement.scrollTop;
    }

    setDialogFlag({
      ...initialForm,
      xCord: x,
      yCord: y,
      maskedvalue: maskedvalues,
      maskedvalueold: maskedvalues,
      documentIndex: parseInt(documentIndex),
    });
  };

  function getElementXPositionValue(value, currentValue, maxWidth) {
    let returnValue = value;
    if (value < 0) {
      returnValue = currentValue === 0 ? 1 : 0;
    }
    if (value > maxWidth) {
      returnValue = currentValue === maxWidth ? maxWidth - 1 : maxWidth;
    }
    return returnValue;
  }
  function getElementYPositionValue(value, currentValue, maxHeight) {
    let returnValue = value;
    if (value < 0) {
      returnValue = currentValue === 0 ? 1 : 0;
    }
    if (value > maxHeight) {
      returnValue = currentValue === maxHeight ? maxHeight - 1 : maxHeight;
    }
    return returnValue;
  }
  //Documents
  //Remove Document
  const removeDocument = (event) => {
    const documentIndex = event.currentTarget.dataset.document_index;
    dispatch({
      type: STEP_2_REMOVE_DOCUMENT,
      payload: documentIndex,
    });
  };
  //Insert Update Document
  const insertUpdateDocument = async (event) => {
    const newFile = event.target.files[0];
    if (newFile) {
      const documentIndex = event.currentTarget.dataset.document_index;
      const funcType = event.currentTarget.dataset.func_type;
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("file", newFile);
        const options = {
          method: "POST",
          url: FILE_UPLOAD_URL,
          headers: authHeader(),
          data: formData,
        };
        Swal.fire(getAlertToast("success", "Please wait..."));
        var apiResponse = await API(options);
        const { status } = apiResponse.data;
        if (status === "Success") {
          const { filepath } = apiResponse.data;
          if (funcType === "insert") {
            dispatch({
              type: STEP_2_INSERT_DOCUMENT_BETWEEN_PAGES,
              payload: filepath,
              documentIndex,
            });
          } else {
            dispatch({
              type: SET_STEP_2_UPDATE_DOCUMENT,
              payload: filepath,
              documentIndex,
            });
          }
        }
      } catch (error) {
        if (error.response) {
          Swal.fire(
            getAlertToast("error", "File upload failed, please try again!")
          );
        }
      } finally {
        setLoading(false);
      }
    }
  };
  //Dialog Toggle
  const dialogClose = () => {
    setDialogFlag(false);
  };
  //Copy Existing Element
  const copyElement = (elementId) => {
    let elementData = elements.find(
      (element) => element.elementId === elementId
    );
    let element = Object.assign({}, elementData);
    element.elementId = shortid.generate();
    elements.push(element);
  };
  //Update Position
  const setElementUpdatedPosition = (
    elementId,
    documentIndex,
    xPosition,
    yPosition
  ) => {
    let isWindows = navigator.platform.indexOf("Win") > -1;
    //copy element on ctrl key and move for windows and Cmd key and move for IOS
    if (
      (isWindows && window.event.ctrlKey) ||
      (!isWindows && window.event.metaKey)
    ) {
      copyElement(elementId);
    }
    const updatedElements = allDocuments[documentIndex].elements.map(
      (item, i) => {
        if (item.elementId === elementId) {
          var canvas = document.getElementById(`canvas_${documentIndex}`);
          let canWidth = parseInt(canvas.width);
          let canHeight = parseInt(canvas.height);
          const maxHeight = canHeight - item.height;
          const maxWidth = canWidth - item.width;
          item.yCord = getElementYPositionValue(
            yPosition,
            item.yCord,
            maxHeight
          );
          item.xCord = getElementXPositionValue(
            xPosition,
            item.xCord,
            maxWidth
          );
          return item;
        } else {
          return item;
        }
      }
    );
    allDocuments[documentIndex].elements = updatedElements;
    dispatch({
      type: STEP_2_UPDATE_DOCUMENTS_ARRAY,
      payload: allDocuments,
    });
  };
  //Update Size
  const setElementUpdatedSize = (elementId, documentIndex, Ewidth, Eheigth) => {
    const updatedElements = allDocuments[documentIndex].elements.map(
      (item, i) => {
        if (item.elementId === elementId) {
          item.width = parseInt(Ewidth.split("px")[0]);
          item.height = parseInt(Eheigth.split("px")[0]);
          return item;
        } else {
          return item;
        }
      }
    );
    allDocuments[documentIndex].elements = updatedElements;
    dispatch({
      type: STEP_2_UPDATE_DOCUMENTS_ARRAY,
      payload: allDocuments,
    });
    setTimerValue(true);
    timerFunction();
  };

  // Timer Function
  const timerFunction = () => {
    setTimeout(() => {
      myFun();
    }, 1000);
  };

  // For Zoom out
  const myFun = () => {
    setTimeout(() => {
      setTimerValue(false);
    }, 500);
    if (value && documentsType !== "WebForm") {
      childRef.current.click();
    }
  };

  useEffect(() => {
    setTimerValue(true);
    timerFunction();
  }, [currentStep, elements.length]);

  useEffect(() => {
    generatePdf();
  }, [documentURL]);


  return (
    <Fragment>
      <center>{loading && <CustomLoader loading={loading} />}</center>
      {/* // Form Dialog  */}
      {!!dialogFlag && (
        <PlaceholderBuildDialog
          dialogFlag={dialogFlag}
          dialogClose={dialogClose}
          elements={elements}
          documentIndex={documentIndex}
          setDialogFlag={setDialogFlag}
          setMaskedvalues={setMaskedvalues}
        />
      )}
      {/* // Form Dialog  */}
      <div style={{ padding: "10px" }}>
        {TimerValue && <CustomPageLoading />}
      </div>

      <TransformWrapper
        defaultScale={1}
        pan={{ disabled: true }}
        defaultPositionX={0}
        defaultPositionY={0}
        PositionX={0}
        PositionY={0}
        limitToBounds={true}
        wheel={{ limitsOnWheel: true }}
        zoomIn={{ step: 6.5 }}
        zoomOut={{ step: 6.5 }}
        doubleClick={{ disabled: true }}
      >
        {({ zoomIn, zoomOut, resetTransform, ...rest }) => {
          setValue(true);
          return (
            <>
              <div
                onClick={resetTransform}
                ref={childRef}
                style={{ display: "none" }}
              >
                Reset
              </div>
              <div
                className=""
                style={{
                  marginBottom: "5px",
                  width: "fix-content",
                  marginLeft: "auto",
                }}
              >
                <Button
                  color="primary"
                  style={{ margin: "2px" }}
                  onClick={zoomIn}
                >
                  +
                </Button>
                <Button
                  color="primary"
                  style={{ margin: "2px" }}
                  onClick={zoomOut}
                >
                  -
                </Button>
                <Button
                  color="primary"
                  style={{ margin: "2px" }}
                  onClick={resetTransform}
                >
                  x
                </Button>
              </div>
              <div
                id="viewPdf"
                style={{
                  position: "relative",
                  alignSelf: "center",
                  width: pdfDimension.width,
                  height: pdfDimension.height,
                }}
              >
                <TransformComponent>
                  <canvas
                    data-document_id={documentIndex}
                    id={`canvas_${documentIndex}`}
                    style={{
                      border: "2px solid #1b3e6f",
                      display: "inline-block",
                      cursor: "pointer",
                    }}
                    onClick={onCanvasClick}
                  ></canvas>
                  {!TimerValue &&
                    elements.map((element, i) => {
                      const {
                        propertyType,
                        elementId,
                        yCord,
                        xCord,
                        fontSize,
                        width,
                        height,
                        isBold,
                        justify,
                        placeholder = "",
                        isRequired,
                        isItalic,
                        checkboxType = "",
                        checkboxSize = "",
                        variableTypeId = 0,
                        variableLabel = "",
                        variableFee = 0,
                        hidePlaceholder = false,
                        characterLimit = 10,
                        maskedvalue,
                      } = element;

                      const mValue =
                        characterLimit &&
                        maskedvalue?.toString()?.length > characterLimit
                          ? maskedvalue
                              ?.toString()
                              ?.substring(0, characterLimit)
                          : maskedvalue;
                      return propertyType === "Text" ||
                        propertyType === "Number" ||
                        propertyType === "Date" ||
                        propertyType === "Signature" ||
                        propertyType === "Image" ||
                        propertyType === "MaskedTextBox" ||
                        (propertyType === "Variable" && variableTypeId !== 1) ? (
                        <Rnd
                          key={`divList_${i}`}
                          id={`doc_${documentIndex}_element_${elementId}`}
                          style={{
                            // fontSize: fontSize + "px",
                            fontSize:
                              propertyType === "Signature"
                                ? "25px"
                                : fontSize + "px",
                            border: isRequired
                              ? "2px solid red"
                              : "2px solid #2900ff",
                            fontWeight: isBold ? "bold" : "normal",
                            fontStyle: isItalic ? "italic" : "normal",
                            textAlign: justify ? justify : "left",
                          }}
                          size={{ width: width, height: height }}
                          position={{ x: xCord, y: yCord }}
                          onDragStop={(e, d) => {
                            setElementUpdatedPosition(
                              elementId,
                              documentIndex,
                              d.x,
                              d.y
                            );
                          }}
                          onResizeStop={(
                            e,
                            direction,
                            ref,
                            delta,
                            position
                          ) => {
                            setElementUpdatedSize(
                              elementId,
                              documentIndex,
                              ref.style.width,
                              ref.style.height
                            );
                          }}
                          onDoubleClick={() => onDoubleClick(elementId)}
                        >
                          {[
                            "Text",
                            "Image",
                            "Signature",
                            "Number",
                            "Date",
                            "MaskedTextBox",
                          ].includes(propertyType)
                            ? hidePlaceholder
                              ? ""
                              : maskedvalue
                              ? mValue
                              : placeholder
                            : hidePlaceholder
                            ? ""
                            : variableTypeId == 3
                            ? variableLabel
                            : variableTypeId == 4
                            ? variableLabel
                            : `$${parseFloat(variableFee).toFixed(
                                2
                              )} - ${variableLabel}`}
                        </Rnd>
                      ) : (
                        <Rnd
                          key={`divList_${i}`}
                          id={`doc_${documentIndex}_element_${elementId}`}
                          enableResizing={
                            propertyType === "Variable" ? true : false
                          }
                          style={{
                            //fontSize: fontSize + "px",
                            fontSize:
                              propertyType === "Signature"
                                ? "25px"
                                : fontSize + "px",
                            // border: isRequired
                            //   ? '2px solid red'
                            //   : '2px solid #2900ff',
                            fontWeight: isBold ? "bold" : "normal",
                            fontStyle: isItalic ? "italic" : "normal",
                            textAlign: justify ? justify : "left",
                            // padding: '3px',
                            width: width ? `${width}px` : "100px",
                            height: height ? `${height}px` : "27px",
                          }}
                          size={{ width: width, height: height }}
                          position={{ x: xCord, y: yCord }}
                          onDragStop={(e, d) => {
                            setElementUpdatedPosition(
                              elementId,
                              documentIndex,
                              d.x,
                              d.y
                            );
                          }}
                          onResizeStop={(
                            e,
                            direction,
                            ref,
                            delta,
                            position
                          ) => {
                            setElementUpdatedSize(
                              elementId,
                              documentIndex,
                              ref.style.width,
                              ref.style.height
                            );
                          }}
                          onDoubleClick={() => onDoubleClick(elementId)}
                        >
                          <div
                            style={{
                              // TESTING-PRODUCTION
                              padding: "2px",
                              border: "2px dashed transparent",
                            }}
                          >
                            <img
                              src={checkboxImagesType[checkboxType]}
                              style={{
                                width: `${checkboxImagesSize[checkboxSize]}px`,
                                height: `${checkboxImagesSize[checkboxSize]}px`,
                                marginRight: `${
                                  propertyType === "Variable" ? 3 : 0
                                }px`,
                                border: isRequired
                                  ? `${
                                      checkboxSize === "Small" ? 1 : 2
                                    }px solid red`
                                  : `${
                                      checkboxSize === "Small" ? 1 : 2
                                    }px solid #2900ff`,
                              }}
                              alt="no data"
                            />

                            {propertyType === "Variable" &&
                              hidePlaceholder == false &&
                              `$${parseFloat(variableFee).toFixed(
                                2
                              )} - ${variableLabel}`}
                          </div>
                        </Rnd>
                      );
                    })}
                </TransformComponent>
              </div>
            </>
          );
        }}
      </TransformWrapper>

      <div style={{ padding: "5px", marginBottom: "3rem" }}>
        {allDocuments.length - 1 !== documentIndex && (
          <label
            style={{ marginBottom: "0" }}
            className="btn-bs-file btn btn-lg btn-warning"
          >
            Insert
            <Input
              type="file"
              accept=".pdf"
              name="insert"
              id={`insert_${documentIndex}`}
              data-document_index={documentIndex}
              data-func_type="insert"
              onChange={insertUpdateDocument}
            />
          </label>
        )}
        <label
          style={{ marginBottom: "0" }}
          className="btn-bs-file btn btn-lg btn-info"
        >
          Update
          <Input
            type="file"
            accept=".pdf"
            name="update"
            id={`update_${documentIndex}`}
            data-document_index={documentIndex}
            data-func_type="update"
            onChange={insertUpdateDocument}
          />
        </label>
        <Button
          color="danger"
          onClick={removeDocument}
          data-document_index={documentIndex}
        >
          Delete
        </Button>
      </div>
    </Fragment>
  );
}
const getState = ({ CreateDocumentForm }) => {
  return {
    CreateDocumentForm,
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      //
    },
    dispatch
  ),
  dispatch,
});
export default connect(getState, mapDispatchToProps)(BuildDocument);
